// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Modal_background__C8uC8 {
  width: 100vw;
  height: 100vh;
  background-color: rgba(42, 40, 40, 0.7);
  position: fixed;
  display: grid;
  grid-template-columns: 65vw 35vw;
  z-index: 100;
}
@media only screen and (max-width: 62.5em) {
  .Modal_background__C8uC8 {
    grid-template-columns: 50vw 50vw;
  }
}
@media only screen and (max-width: 50em) {
  .Modal_background__C8uC8 {
    grid-template-columns: 35vw 65vw;
  }
}
@media only screen and (max-width: 31.25em) {
  .Modal_background__C8uC8 {
    grid-template-columns: 100vw;
    grid-template-rows: 1fr max-content;
  }
}

.Modal_container__LE2t1 {
  width: 100%;
  min-height: 100vh;
  background-color: var(--color-white);
  box-sizing: border-box;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  padding: 3rem;
  position: relative;
  bottom: 0;
  grid-column: 2/3;
  overflow-y: scroll;
  overflow-x: hidden;
}
.Modal_container__LE2t1::-webkit-scrollbar {
  width: 1rem;
  background-color: var(--color-white);
  border-radius: 0 1rem 1rem 0;
}
.Modal_container__LE2t1::-webkit-scrollbar-thumb {
  background-color: var(--color-grey);
  border-radius: 1rem;
}
@media only screen and (max-width: 31.25em) {
  .Modal_container__LE2t1 {
    grid-column: 1/1;
    border-radius: 5rem 5rem 0 0;
    min-height: 30vh;
    max-height: 85vh;
  }
}
.Modal_container__top__4QJFC {
  position: fixed;
  font-size: 5rem;
  display: flex;
  justify-content: space-between;
  z-index: 10;
  height: 7rem;
}
.Modal_container__top__4QJFC > :first-child {
  cursor: pointer;
}
.Modal_container__top__4QJFC > :first-child:hover {
  color: var(--color-primary);
}

.Modal_bws__1xdpZ {
  content: "";
  background-color: var(--color-white);
  width: 100%;
  height: 2rem;
}

.Modal_content__z2Bau {
  min-height: 75vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}
@media only screen and (max-width: 31.25em) {
  .Modal_content__z2Bau {
    margin: 8rem 0 8rem 0;
    min-height: fit-content;
  }
}

.Modal_close__XMVHQ {
  position: fixed;
  right: 3rem;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Modal/Modal.module.scss"],"names":[],"mappings":"AAEA;EACC,YAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,aAAA;EACA,gCAAA;EACA,YAAA;AADD;AAGC;EATD;IAUE,gCAAA;EAAA;AACF;AAEC;EAbD;IAcE,gCAAA;EACA;AACF;AAAC;EAhBD;IAiBE,4BAAA;IACA,mCAAA;EAGA;AACF;;AAAA;EACC,WAAA;EACA,iBAAA;EACA,oCAAA;EACA,sBAAA;EACA,4CAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAGD;AADC;EACC,WAAA;EACA,oCAAA;EACA,4BAAA;AAGF;AAAC;EACC,mCAAA;EACA,mBAAA;AAEF;AACC;EAxBD;IAyBE,gBAAA;IACA,4BAAA;IACA,gBAAA;IACA,gBAAA;EAEA;AACF;AAAC;EACC,eAAA;EAEA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;AACF;AACE;EACC,eAAA;AACH;AAAG;EACC,2BAAA;AAEJ;;AAIA;EACC,WAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;AADD;;AAIA;EACC,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AADD;AAGC;EARD;IASE,qBAAA;IACA,uBAAA;EAAA;AACF;;AAGA;EACC,eAAA;EACA,WAAA;EACA,eAAA;AAAD","sourcesContent":["@import '../variables/breakpoints';\n\n.background {\n\twidth: 100vw;\n\theight: 100vh;\n\tbackground-color: rgba(#2a2828, 0.7);\n\tposition: fixed;\n\tdisplay: grid;\n\tgrid-template-columns: 65vw 35vw;\n\tz-index: 100;\n\n\t@media only screen and (max-width: $bp-1000) {\n\t\tgrid-template-columns: 50vw 50vw;\n\t}\n\n\t@media only screen and (max-width: $bp-800) {\n\t\tgrid-template-columns: 35vw 65vw;\n\t}\n\t@media only screen and (max-width: $bp-500) {\n\t\tgrid-template-columns: 100vw;\n\t\tgrid-template-rows: 1fr max-content;\n\t}\n}\n\n.container {\n\twidth: 100%;\n\tmin-height: 100vh;\n\tbackground-color: var(--color-white);\n\tbox-sizing: border-box;\n\tbox-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n\tpadding: 3rem;\n\tposition: relative;\n\tbottom: 0;\n\tgrid-column: 2/3;\n\toverflow-y: scroll;\n\toverflow-x: hidden;\n\n\t&::-webkit-scrollbar {\n\t\twidth: 1rem;\n\t\tbackground-color: var(--color-white);\n\t\tborder-radius: 0 1rem 1rem 0;\n\t}\n\n\t&::-webkit-scrollbar-thumb {\n\t\tbackground-color: var(--color-grey);\n\t\tborder-radius: 1rem;\n\t}\n\n\t@media only screen and (max-width: $bp-500) {\n\t\tgrid-column: 1/1;\n\t\tborder-radius: 5rem 5rem 0 0;\n\t\tmin-height: 30vh;\n\t\tmax-height: 85vh;\n\t}\n\n\t&__top {\n\t\tposition: fixed;\n\t\t// background-color: var(--color-white);\n\t\tfont-size: 5rem;\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tz-index: 10;\n\t\theight: 7rem;\n\n\t\t& > :first-child {\n\t\t\tcursor: pointer;\n\t\t\t&:hover {\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.bws {\n\tcontent: '';\n\tbackground-color: var(--color-white);\n\twidth: 100%;\n\theight: 2rem;\n}\n\n.content {\n\tmin-height: 75vh;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tposition: relative;\n\n\t@media only screen and (max-width: $bp-500) {\n\t\tmargin: 8rem 0 8rem 0;\n\t\tmin-height: fit-content;\n\t}\n}\n\n.close {\n\tposition: fixed;\n\tright: 3rem;\n\tcursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"background": `Modal_background__C8uC8`,
	"container": `Modal_container__LE2t1`,
	"container__top": `Modal_container__top__4QJFC`,
	"bws": `Modal_bws__1xdpZ`,
	"content": `Modal_content__z2Bau`,
	"close": `Modal_close__XMVHQ`
};
export default ___CSS_LOADER_EXPORT___;
